import { render } from "./ChurchLifeRequestCard.vue?vue&type=template&id=5f2e9ee0&scoped=true"
import script from "./ChurchLifeRequestCard.vue?vue&type=script&lang=js"
export * from "./ChurchLifeRequestCard.vue?vue&type=script&lang=js"

import "./ChurchLifeRequestCard.vue?vue&type=style&index=0&id=5f2e9ee0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5f2e9ee0"]])

export default __exports__